module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-06.6e032629.svg";